var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndoTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.765641 3.11717L3.2858 0.531777C3.61395 0.195137 4.14686 0.195137 4.47501 0.531777C4.80315 0.868416 4.80315 1.41512 4.47501 1.75176L3.39344 2.86132H6.39926C8.71466 2.86132 10.5995 4.79498 10.5995 7.17031C10.5995 9.54564 8.71466 11.4793 6.39926 11.4793C5.9346 11.4793 5.5592 11.0942 5.5592 10.6175C5.5592 10.1408 5.9346 9.7557 6.39926 9.7557C7.78797 9.7557 8.91942 8.59497 8.91942 7.17031C8.91942 5.74565 7.78797 4.58492 6.39926 4.58492H3.38031L4.46713 5.69987C4.79528 6.03651 4.79528 6.58321 4.46713 6.91985C4.30437 7.08682 4.08911 7.173 3.87384 7.173C3.65858 7.173 3.44332 7.08952 3.28055 6.91985L0.765641 4.33446C0.437495 3.99782 0.437495 3.45381 0.765641 3.11717Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoTarget);
export default __webpack_public_path__ + "static/media/undoTarget.cf7ec28b920043ae48a3f25089a43e6a.svg";
export { ForwardRef as ReactComponent };